const termsGR = {
  title: "Όροι Χρήσης",
  effectiveDate: "14 Οκτωβρίου 2026",
  intro: `Καλώς ήρθατε στο Agapaé. Οι παρόντες Όροι Χρήσης ("Όροι") αποτελούν νομικά δεσμευτική συμφωνία μεταξύ εσάς ("Χρήστης", "εσείς") και της EnQube ΙΚΕ ("Εταιρεία", "εμείς", "μας"), εταιρείας που εδρεύει στην Πάτρα, Ελλάδα, που διέπει την πρόσβαση και χρήση της πλατφόρμας Agapaé, συμπεριλαμβανομένου του ιστότοπου, των εφαρμογών και των σχετικών υπηρεσιών μας (συλλογικά, η "Πλατφόρμα").

Δημιουργώντας λογαριασμό, αποκτώντας πρόσβαση ή χρησιμοποιώντας την Πλατφόρμα, αναγνωρίζετε ότι έχετε διαβάσει, κατανοήσει και αποδέχεστε τους παρόντες Όρους. Εάν δεν συμφωνείτε, παρακαλούμε μη χρησιμοποιήσετε την Πλατφόρμα.`,

  sections: [
    {
      heading: "1. Ορισμοί",
      content: [
        `Για τους σκοπούς των παρόντων Όρων:`,
        {
          type: "list",
          items: [
            `"Πλατφόρμα": η διαδικτυακή εφαρμογή Agapaé, οι διεπαφές για κινητές συσκευές, τα προγραμματιστικά διεπαφών (APIs) και όλες οι σχετικές υπηρεσίες που λειτουργούν από την EnQube ΙΚΕ.`,
            `"Ζευγάρι" ή "Διοργανωτής Εκδήλωσης": ο εγγεγραμμένος χρήστης που δημιουργεί και διαχειρίζεται έναν γάμο ή άλλη εκδήλωση στην Πλατφόρμα.`,
            `"Καλεσμένος": κάθε φυσικό πρόσωπο που αποκτά πρόσβαση σε εκδήλωση μέσω πρόσκλησης ή κωδικού σύνδεσης, ανεξάρτητα από το εάν διαθέτει εγγεγραμμένο λογαριασμό.`,
            `"Περιεχόμενο": κάθε κείμενο, φωτογραφία, βίντεο, ηχητικό αρχείο, δεδομένο ή άλλο υλικό που μεταφορτώνεται, υποβάλλεται ή εμφανίζεται στην Πλατφόρμα από τον Χρήστη.`,
            `"Δεδομένα Εκδήλωσης": το σύνολο των πληροφοριών που σχετίζονται με συγκεκριμένη εκδήλωση, περιλαμβανομένων ενδεικτικά των λεπτομερειών της, της λίστας καλεσμένων, του υλικού πολυμέσων, του προγράμματος και των σχετικών ρυθμίσεων.`,
            `"Πακέτο Υπηρεσίας": το επίπεδο υπηρεσίας που επιλέγεται από το Ζευγάρι (Blossom, Bouquet ή Heirloom), εκάστου με συγκεκριμένα χαρακτηριστικά, όρια αποθήκευσης και τιμολόγηση.`,
          ],
        },
      ],
    },
    {
      heading: "2. Προϋποθέσεις και Εγγραφή Λογαριασμού",
      content: [
        `Για τη δημιουργία λογαριασμού στην Πλατφόρμα, πρέπει:`,
        {
          type: "list",
          items: [
            `Να είστε τουλάχιστον δεκαοκτώ (18) ετών ή να έχετε συμπληρώσει την ηλικία ενηλικίωσης στη χώρα κατοικίας σας·`,
            `Να έχετε τη νομική ικανότητα σύναψης δεσμευτικής συμφωνίας·`,
            `Να παρέχετε ακριβή, πλήρη και τρέχοντα στοιχεία εγγραφής, συμπεριλαμβανομένης έγκυρης διεύθυνσης email και ασφαλούς κωδικού πρόσβασης.`,
          ],
        },
        `Είστε υπεύθυνοι για τη διατήρηση της εμπιστευτικότητας των στοιχείων σύνδεσής σας και για όλες τις δραστηριότητες στον λογαριασμό σας. Πρέπει να μας ενημερώσετε αμέσως στο privacy@agapae.gr εάν αντιληφθείτε οποιαδήποτε μη εξουσιοδοτημένη χρήση του λογαριασμού σας.`,
        `Διατηρούμε το δικαίωμα αναστολής ή τερματισμού λογαριασμών που περιέχουν ανακριβείς πληροφορίες ή παραβιάζουν τους παρόντες Όρους.`,
      ],
    },
    {
      heading: "3. Η Υπηρεσία",
      content: [
        `Το Agapaé είναι μια πλατφόρμα διαχείρισης γάμων και εκδηλώσεων που επιτρέπει στα Ζευγάρια να:`,
        {
          type: "list",
          items: [
            `Δημιουργήσουν και προσαρμόσουν μια ψηφιακή εμπειρία γάμου·`,
            `Μοιραστούν λεπτομέρειες εκδήλωσης, πρόγραμμα και πληροφορίες τοποθεσίας·`,
            `Προσκαλέσουν καλεσμένους να δουν πληροφορίες εκδήλωσης και να συνεισφέρουν πολυμέσα·`,
            `Συλλέξουν και οργανώσουν φωτογραφίες και βίντεο από την εκδήλωσή τους·`,
            `Μοιραστούν την ιστορία αγάπης τους μέσω αφηγηματικών χαρακτηριστικών·`,
            `Διαχειριστούν προτιμήσεις δώρων και πληροφορίες μητρώου·`,
            `Χρησιμοποιήσουν έναν βοηθό AI για την οργάνωση (Ἔρως) σε κατάλληλα Πακέτα Υπηρεσίας.`,
          ],
        },
        `Η Πλατφόρμα παρέχεται "ως έχει" και "ως διατίθεται". Με την επιφύλαξη της εφαρμοστέας νομοθεσίας προστασίας του καταναλωτή, εργαζόμαστε συνεχώς για τη βελτίωση της υπηρεσίας, χωρίς ωστόσο να εγγυόμαστε αδιάλειπτη ή απαλλαγμένη από σφάλματα λειτουργία.`,
        {
          type: "emphasis",
          text: "Βοηθός AI (Ἔρως)",
        },
        `Σε κατάλληλα Πακέτα Υπηρεσίας, η Πλατφόρμα προσφέρει τον Ἔρως, έναν προαιρετικό βοηθό AI που σας βοηθά στην οργάνωση της εκδήλωσής σας. Ο Ἔρως παρέχεται "ως έχει" και ενδέχεται να παράγει αποτελέσματα ανακριβή, ελλιπή ή ακατάλληλα για την περίπτωσή σας. Δεν συνιστά επαγγελματική, νομική, οικονομική ή ιατρική συμβουλή. Παραμένετε υπεύθυνοι για τον έλεγχο των προτάσεών του και για κάθε απόφαση που λαμβάνετε. Για λεπτομέρειες σχετικά με την επεξεργασία δεδομένων κατά τη χρήση του Ἔρως — συμπεριλαμβανομένων των τρίτων παρόχων AI που εμπλέκονται — δείτε την Πολιτική Απορρήτου μας.`,
      ],
    },
    {
      heading: "4. Πακέτα Υπηρεσίας και Πληρωμές",
      content: [
        `Η Πλατφόρμα προσφέρει τα ακόλουθα Πακέτα Υπηρεσίας:`,
        {
          type: "list",
          items: [
            `Blossom (Δωρεάν): έως 100 φωτογραφίες (μόνο ανέβασμα φωτογραφιών· το ανέβασμα βίντεο διατίθεται στα Bouquet και Heirloom), έως 20 καλεσμένοι, 15 ημέρες διατήρηση μετά την εκδήλωση.`,
            `Bouquet (€99 εφάπαξ): 50 GB αποθηκευτικός χώρος, έως 200 καλεσμένοι, 60 ημέρες διατήρηση μετά την εκδήλωση.`,
            `Heirloom (€249 εφάπαξ): 200 GB αποθηκευτικός χώρος, έως 1.500 καλεσμένοι υπό εύλογη χρήση, 90 ημέρες διατήρηση μετά την εκδήλωση.`,
          ],
        },
        `Οι εκδηλώσεις Blossom που δημιουργήθηκαν πριν από τις 14 Οκτωβρίου 2026 διατηρούν τα όρια του προηγούμενου πακέτου Blossom: έως 50 καλεσμένους, ανέβασμα φωτογραφιών και βίντεο και 2 GB αποθηκευτικό χώρο.`,
        `Όλες οι τιμές είναι σε Ευρώ (EUR) και περιλαμβάνουν τους ισχύοντες φόρους, εκτός αν αναφέρεται διαφορετικά. Οι πληρωμές επεξεργάζονται με ασφάλεια μέσω Stripe. Δεν αποθηκεύουμε στοιχεία πληρωτικών καρτών στους διακομιστές μας.`,
        `Διατηρούμε το δικαίωμα τροποποίησης τιμών για μελλοντικές αγορές. Τυχόν αλλαγές τιμών δεν θα επηρεάσουν ήδη αγορασμένα πακέτα.`,
        `Χαρακτηριστικά AI, όπως ο βοηθός οργάνωσης Ἔρως, ενδέχεται να περιλαμβάνονται σε ορισμένα Πακέτα Υπηρεσίας που αγοράζονται κατά τη διάρκεια προωθητικής ή εισαγωγικής περιόδου. Όταν ένα χαρακτηριστικό AI περιλαμβάνεται στο Πακέτο Υπηρεσίας σας κατά τη στιγμή της αγοράς, παραμένει διαθέσιμο για την οργάνωση της συγκεκριμένης εκδήλωσης σύμφωνα με το πακέτο σας. Εκτός τέτοιων περιόδων, τα χαρακτηριστικά AI ενδέχεται να προσφέρονται ως ξεχωριστή πρόσθετη υπηρεσία επί πληρωμή. Η διαθεσιμότητα, τα όρια χρήσης και η τιμολόγηση των χαρακτηριστικών AI ενδέχεται να μεταβληθούν για μελλοντικές αγορές· τέτοιες αλλαγές δεν θα επηρεάσουν χαρακτηριστικά που περιλαμβάνονται ήδη σε υφιστάμενο πληρωμένο πακέτο, ενώ θα παρέχουμε εύλογη προειδοποίηση για ουσιώδεις αλλαγές.`,
      ],
    },
    {
      heading: "5. Το Περιεχόμενό σας και η Ρήτρα Αναμνήσεων",
      content: [
        `Οι αναμνήσεις σας ανήκουν αποκλειστικά σε εσάς. Πιστεύουμε ότι οι φωτογραφίες, τα βίντεο, οι ιστορίες και τα προσωπικά στοιχεία που εμπιστεύεστε στο Agapaé είναι βαθιά προσωπικά, και τα αντιμετωπίζουμε με την ανάλογη ευθύνη.`,
        {
          type: "emphasis",
          text: "Ιδιοκτησία",
        },
        `Διατηρείτε πλήρη και αποκλειστική πνευματική ιδιοκτησία επί όλου του Περιεχομένου που ανεβάζετε, δημιουργείτε ή υποβάλλετε στην Πλατφόρμα. Τίποτα στους παρόντες Όρους δεν μεταβιβάζει την ιδιοκτησία του Περιεχομένου σας σε εμάς.`,
        {
          type: "emphasis",
          text: "Περιορισμένη Άδεια",
        },
        `Με τη μεταφόρτωση Περιεχομένου στην Πλατφόρμα, παραχωρείτε στην EnQube ΙΚΕ περιορισμένη, μη αποκλειστική, μη μεταβιβάσιμη και ανακλητή άδεια για τη φιλοξενία, αποθήκευση, εμφάνιση, αναπαραγωγή και επεξεργασία του Περιεχομένου σας, αποκλειστικά για τον σκοπό της παροχής και βελτίωσης της Υπηρεσίας. Στις ενέργειες αυτές περιλαμβάνονται η δημιουργία μικρογραφιών, η μετατροπή βίντεο για βέλτιστη αναπαραγωγή και η διάθεση του Περιεχομένου σας σε εξουσιοδοτημένους θεατές.`,
        `Η άδεια αυτή υφίσταται μόνο όσο το Περιεχόμενό σας παραμένει στην Πλατφόρμα και τερματίζεται αυτόματα όταν διαγράψετε το Περιεχόμενό σας ή όταν τα Δεδομένα Εκδήλωσης αφαιρεθούν σύμφωνα με την περίοδο διατήρησης του Πακέτου Υπηρεσίας σας.`,
        `Δεν θα πωλήσουμε, παραχωρήσουμε υποάδεια ή χρησιμοποιήσουμε ποτέ το Περιεχόμενό σας για διαφήμιση, μάρκετινγκ ή οποιονδήποτε σκοπό που δεν σχετίζεται με την παροχή της Υπηρεσίας.`,
      ],
    },
    {
      heading: "6. Περιεχόμενο Χρηστών",
      content: [
        `Είστε αποκλειστικά υπεύθυνοι για το Περιεχόμενο που ανεβάζετε ή μοιράζεστε μέσω της Πλατφόρμας. Υποβάλλοντας Περιεχόμενο, δηλώνετε και εγγυάστε ότι:`,
        {
          type: "list",
          items: [
            `Κατέχετε ή έχετε τα απαραίτητα δικαιώματα και άδειες για ανέβασμα και κοινοποίηση του Περιεχομένου·`,
            `Το Περιεχόμενο δεν παραβιάζει πνευματικά δικαιώματα, ιδιωτικότητα ή άλλα δικαιώματα τρίτων·`,
            `Το Περιεχόμενο δεν περιέχει παράνομο, δυσφημιστικό, άσεμνο ή κατά τα άλλα προσβλητικό υλικό·`,
            `Το Περιεχόμενο δεν περιέχει κακόβουλο λογισμικό, ιούς ή άλλο επιβλαβή κώδικα.`,
          ],
        },
        `Διατηρούμε το δικαίωμα αφαίρεσης Περιεχομένου που παραβιάζει τους παρόντες Όρους ή την ισχύουσα νομοθεσία, χωρίς προηγούμενη ειδοποίηση. Για λόγους σαφήνειας, η άσκηση του δικαιώματος αυτού για την αφαίρεση προσβλητικού Περιεχομένου δεν συνιστά παραβίαση των εγγυήσεων ιδιοκτησίας ή της Ρήτρας Αναμνήσεων που προβλέπονται στην Ενότητα 5.`,
      ],
    },
    {
      heading: "7. Ρήτρα Δεδομένων Καλεσμένων",
      content: [
        `Ως μέρος της Υπηρεσίας, τα Ζευγάρια μπορούν να εισάγουν, διαχειρίζονται και μοιράζονται προσωπικά δεδομένα των Καλεσμένων τους, συμπεριλαμβανομένων ονομάτων και διευθύνσεων email.`,
        {
          type: "emphasis",
          text: "Ευθύνη του Ζευγαριού",
        },
        `Όταν εσείς, ως Ζευγάρι, παρέχετε προσωπικά δεδομένα σχετικά με τους Καλεσμένους σας, ενεργείτε ως υπεύθυνος επεξεργασίας δεδομένων σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR). Είστε υπεύθυνοι να διασφαλίσετε ότι διαθέτετε νόμιμη βάση για τη διαβίβαση των δεδομένων αυτών στην Πλατφόρμα — είτε μέσω της συγκατάθεσης του Καλεσμένου, είτε μέσω έννομου συμφέροντος που απορρέει από την εκδήλωση του γάμου σας, είτε μέσω άλλης εφαρμοστέας νομικής βάσης.`,
        {
          type: "emphasis",
          text: "Ρόλος της Πλατφόρμας",
        },
        `Η EnQube ΙΚΕ επεξεργάζεται δεδομένα Καλεσμένων για λογαριασμό του Ζευγαριού ως εκτελούσα την επεξεργασία. Επεξεργαζόμαστε δεδομένα Καλεσμένων αποκλειστικά για τον σκοπό παροχής της Υπηρεσίας και σύμφωνα με τις οδηγίες του Ζευγαριού, την Πολιτική Απορρήτου μας και τη Συμφωνία Επεξεργασίας Δεδομένων που ενσωματώνεται στους παρόντες Όρους.`,
        `Οι Καλεσμένοι που συμμετέχουν σε εκδήλωση παρέχουν το όνομά τους όπως επιθυμούν να εμφανίζεται και, όπου τούτο απαιτείται από το Ζευγάρι, τη διεύθυνση email τους. Οι Καλεσμένοι έχουν επίσης τη δυνατότητα να μεταφορτώσουν Περιεχόμενο στην κοινόχρηστη γκαλερί της εκδήλωσης.`,
      ],
    },
    {
      heading: "8. Αποδεκτή Χρήση",
      content: [
        `Συμφωνείτε να μη χρησιμοποιείτε την Πλατφόρμα για:`,
        {
          type: "list",
          items: [
            `Παραβίαση οποιασδήποτε εφαρμοστέας τοπικής, εθνικής ή διεθνούς νομοθεσίας·`,
            `Ανέβασμα, κοινοποίηση ή διανομή Περιεχομένου που είναι παράνομο, επιβλαβές, απειλητικό, καταχρηστικό, δυσφημιστικό ή κατά τα άλλα προσβλητικό·`,
            `Υπόδυση οποιουδήποτε προσώπου ή οντότητας ή παραποίηση της σχέσης σας με αυτά·`,
            `Παρέμβαση ή διατάραξη της υποδομής, ασφάλειας ή εμπειρίας άλλων χρηστών·`,
            `Απόπειρα μη εξουσιοδοτημένης πρόσβασης στην Πλατφόρμα, άλλους λογαριασμούς ή συστήματα·`,
            `Χρήση αυτοματοποιημένων scripts, αυτοματοποιημένων προγραμμάτων (bots) ή εργαλείων εξόρυξης περιεχομένου (scrapers) για πρόσβαση ή αλληλεπίδραση με την Πλατφόρμα·`,
            `Χρήση της Πλατφόρμας για εμπορικούς σκοπούς μη εξουσιοδοτημένους από τους παρόντες Όρους·`,
            `Συλλογή ή αποθήκευση προσωπικών δεδομένων άλλων χρηστών χωρίς τη συγκατάθεσή τους.`,
          ],
        },
        `Η παραβίαση αυτών των διατάξεων μπορεί να οδηγήσει σε άμεση αναστολή ή τερματισμό του λογαριασμού σας.`,
      ],
    },
    {
      heading: "9. Πάροχοι Υπηρεσιών και Επαγγελματίες Χρήστες",
      content: [
        `Η Πλατφόρμα μπορεί στο μέλλον να προσφέρει δυνατότητες για παρόχους γαμήλιων υπηρεσιών και επαγγελματίες. Εάν και όταν τέτοιες δυνατότητες γίνουν διαθέσιμες, οι επαγγελματίες χρήστες θα υπόκεινται σε πρόσθετους όρους ειδικούς για εμπορική χρήση.`,
        `Η Πλατφόρμα δεν λειτουργεί επί του παρόντος ως αγορά. Δεν προτείνουμε, εγγυόμαστε ή αναλαμβάνουμε ευθύνη για υπηρεσίες που προσφέρονται από τρίτους παρόχους, ανεξαρτήτως αν αναφέρονται στην Πλατφόρμα.`,
      ],
    },
    {
      heading: "10. Πνευματική Ιδιοκτησία",
      content: [
        `Η Πλατφόρμα — συμπεριλαμβανομένου του σχεδιασμού, κώδικα, branding, λογοτύπων, κειμένου, γραφικών και όλων των άλλων ιδιόκτητων υλικών — ανήκει στην EnQube ΙΚΕ και προστατεύεται από ελληνικούς, ευρωπαϊκούς και διεθνείς νόμους πνευματικής ιδιοκτησίας.`,
        `Δεν επιτρέπεται η αντιγραφή, τροποποίηση, διανομή, πώληση ή δημιουργία παράγωγων έργων βασισμένων στην Πλατφόρμα ή τα ιδιόκτητα υλικά της χωρίς την προηγούμενη γραπτή μας συγκατάθεση.`,
        `Η ονομασία "Agapaé" και τα συσχετιζόμενα λογότυπα είναι εμπορικά σήματα της EnQube ΙΚΕ. Η μη εξουσιοδοτημένη χρήση απαγορεύεται.`,
      ],
    },
    {
      heading: "11. Δικαίωμα Υπαναχώρησης",
      content: [
        `Σύμφωνα με την Οδηγία 2011/83/ΕΕ περί δικαιωμάτων των καταναλωτών και τον Ν. 2251/1994, εάν είστε καταναλωτής εντός της Ευρωπαϊκής Ένωσης, έχετε δικαίωμα υπαναχώρησης από αγορά εντός δεκατεσσάρων (14) ημερολογιακών ημερών από τη συναλλαγή, χωρίς υποχρέωση αιτιολόγησης.`,
        {
          type: "emphasis",
          text: "Εκτέλεση σε Σχέση με την Ημερομηνία του Γάμου",
        },
        `Η Πλατφόρμα αποτελεί υπηρεσία η οποία εκτελείται σε συνάρτηση με συγκεκριμένη ημερομηνία εκδήλωσης — τον γάμο σας. Επιλέγοντας ένα πληρωμένο Πακέτο Υπηρεσίας, αναγνωρίζετε ότι η υπηρεσία συνδέεται με την ημερομηνία αυτή και ότι η εκτέλεσή της ολοκληρώνεται μέχρι τη στιγμή πραγματοποίησης του γάμου σας. Σύμφωνα με το άρθρο 16(α) της Οδηγίας 2011/83/ΕΕ, το δικαίωμα υπαναχώρησης αποσβέννυται με την εκτέλεση της υπηρεσίας.`,
        {
          type: "emphasis",
          text: "Πολιτική Επιστροφής Χρημάτων",
        },
        `Ειδικότερα:`,
        {
          type: "list",
          items: [
            `Μπορείτε να ζητήσετε επιστροφή χρημάτων εντός δεκατεσσάρων (14) ημερολογιακών ημερών από την πληρωμή, εφόσον ο γάμος σας δεν έχει ακόμη πραγματοποιηθεί. Σε αυτή την περίπτωση, θα επιστραφεί ολόκληρο το ποσό που καταβλήθηκε για το Πακέτο Υπηρεσίας σας·`,
            `Εάν η ημερομηνία του γάμου σας εμπίπτει εντός του 14ήμερου, το δικαίωμα υπαναχώρησης ισχύει μόνο έως την παραμονή του γάμου. Από την ημερομηνία του γάμου και μετά, η υπηρεσία θεωρείται πλήρως εκτελεσθείσα και δεν είναι πλέον διαθέσιμη επιστροφή χρημάτων·`,
            `Μετά την παρέλευση της ημερομηνίας του γάμου σας, δεν μπορεί να χορηγηθεί επιστροφή χρημάτων, καθώς η υπηρεσία έχει εκτελεστεί.`,
          ],
        },
        {
          type: "emphasis",
          text: "Πώς να Ζητήσετε Επιστροφή Χρημάτων",
        },
        `Για την άσκηση του δικαιώματος υπαναχώρησής σας, επικοινωνήστε μαζί μας στο support@agapae.gr πριν από τη λήξη της ισχύουσας προθεσμίας. Σχετική υπενθύμιση των ανωτέρω όρων περιλαμβάνεται στο email επιβεβαίωσης της αγοράς σας.`,
      ],
    },
    {
      heading: "12. Περιορισμός Ευθύνης",
      content: [
        `Στο μέγιστο βαθμό που επιτρέπεται από την εφαρμοστέα νομοθεσία, η συνολική ευθύνη της EnQube ΙΚΕ προς εσάς για οποιεσδήποτε αξιώσεις που προκύπτουν από ή σχετίζονται με τους παρόντες Όρους ή την Υπηρεσία δεν θα υπερβαίνει το σύνολο των ποσών που καταβάλατε σε εμάς κατά τους δώδεκα (12) μήνες που προηγήθηκαν του γεγονότος το οποίο προκάλεσε την αξίωση.`,
        `Ο περιορισμός αυτός δεν ισχύει και τίποτα στους παρόντες Όρους δεν θα περιορίσει ή αποκλείσει την ευθύνη μας για:`,
        {
          type: "list",
          items: [
            `Θάνατο ή σωματική βλάβη που προκαλείται από αμέλειά μας·`,
            `Απάτη ή δόλια ψευδή δήλωση·`,
            `Βαριά αμέλεια ή δόλο·`,
            `Οποιαδήποτε ευθύνη που δεν μπορεί να περιοριστεί ή αποκλειστεί βάσει εφαρμοστέας νομοθεσίας, συμπεριλαμβανομένων υποχρεωτικών νόμων προστασίας καταναλωτή της ΕΕ ή της Ελλάδας.`,
          ],
        },
        `Δεν ευθυνόμαστε για οποιαδήποτε έμμεση ή αποθετική ζημία, περιλαμβανομένων διαφυγόντων κερδών, απώλειας δεδομένων ή φήμης, που προκύπτουν από τη χρήση ή την αδυναμία χρήσης της Πλατφόρμας.`,
        `Οι προτάσεις που παράγονται από AI παρέχονται μόνο για διευκόλυνση και ενδέχεται να είναι ανακριβείς ή ελλιπείς· στο μέγιστο βαθμό που επιτρέπεται από τη νομοθεσία, δεν φέρουμε ευθύνη για ενέργειες που βασίζονται σε αποτελέσματα παραγόμενα από AI.`,
        `Δεν ευθυνόμαστε για απώλεια Περιεχομένου λόγω περιστάσεων πέρα από τον εύλογο έλεγχό μας, περιλαμβανομένων ενδεικτικά καταστροφής δεδομένων, αστοχιών υπηρεσιών τρίτων, αστοχιών υποδομής υπολογιστικού νέφους (cloud) ή τρίτων παρόχων φιλοξενίας, καθώς και γεγονότων ανωτέρας βίας. Συνιστούμε ανεπιφύλακτα να διατηρείτε ανεξάρτητα αντίγραφα ασφαλείας του σημαντικού σας περιεχομένου.`,
      ],
    },
    {
      heading: "13. Αποζημίωση από τον Χρήστη",
      content: [
        `Συμφωνείτε να αποζημιώσετε και να απαλλάξετε από κάθε ευθύνη την EnQube ΙΚΕ, τα στελέχη της διοίκησης, τους διευθυντές, τους εργαζομένους και τους αντιπροσώπους της, για οποιεσδήποτε αξιώσεις, ευθύνες, ζημίες, απώλειες και έξοδα (περιλαμβανομένων εύλογων δικηγορικών αμοιβών) που τυχόν προκύψουν από ή σε σχέση με:`,
        {
          type: "list",
          items: [
            `Τη χρήση της Πλατφόρμας από εσάς·`,
            `Την παραβίαση των παρόντων Όρων·`,
            `Την παραβίαση οποιασδήποτε εφαρμοστέας νομοθεσίας·`,
            `Οποιοδήποτε Περιεχόμενο ανεβάζετε, υποβάλλετε ή μοιράζεστε μέσω της Πλατφόρμας·`,
            `Την παροχή δεδομένων Καλεσμένων στην Πλατφόρμα χωρίς κατάλληλη νόμιμη βάση.`,
          ],
        },
      ],
    },
    {
      heading: "14. Τερματισμός και Αναστολή",
      content: [
        {
          type: "emphasis",
          text: "Τερματισμός από εσάς",
        },
        `Μπορείτε να τερματίσετε τον λογαριασμό σας ανά πάσα στιγμή επικοινωνώντας μαζί μας στο privacy@agapae.gr. Μετά τον τερματισμό, τα Δεδομένα Εκδήλωσης θα διατηρηθούν για το υπόλοιπο της ισχύουσας περιόδου διατήρησης, μετά την οποία θα διαγραφούν μόνιμα.`,
        {
          type: "emphasis",
          text: "Τερματισμός ή Αναστολή από εμάς",
        },
        `Μπορούμε να αναστείλουμε ή τερματίσουμε την πρόσβασή σας, με ή χωρίς ειδοποίηση, εάν:`,
        {
          type: "list",
          items: [
            `Παραβιάσετε τους παρόντες Όρους·`,
            `Η χρήση σας αποτελεί κίνδυνο ασφαλείας ή μπορεί να βλάψει άλλους χρήστες·`,
            `Απαιτηθεί από τη νομοθεσία·`,
            `Διακόψουμε την Υπηρεσία (οπότε θα δοθεί εύλογη προηγούμενη ειδοποίηση και δυνατότητα εξαγωγής των δεδομένων σας).`,
          ],
        },
        {
          type: "emphasis",
          text: "Αποτελέσματα Τερματισμού",
        },
        `Μετά τον τερματισμό, παύει το δικαίωμα πρόσβασής σας στην Πλατφόρμα. Ενότητες των παρόντων Όρων οι οποίες από τη φύση τους πρέπει να διατηρήσουν την ισχύ τους μετά τη λήξη της σύμβασης (περιλαμβανομένων των ενοτήτων περί Πνευματικής Ιδιοκτησίας, Περιορισμού Ευθύνης, Αποζημίωσης και Εφαρμοστέου Δικαίου) εξακολουθούν να ισχύουν ως μετασυμβατικές υποχρεώσεις.`,
      ],
    },
    {
      heading: "15. Διατήρηση Δεδομένων",
      content: [
        `Τα Δεδομένα Εκδήλωσης, συμπεριλαμβανομένων των μεταφορτωμένων πολυμέσων, διατηρούνται στην Πλατφόρμα σύμφωνα με το Πακέτο Υπηρεσίας σας:`,
        {
          type: "list",
          items: [
            `Blossom (Δωρεάν): 15 ημέρες μετά την ημερομηνία εκδήλωσης`,
            `Bouquet: 60 ημέρες μετά την ημερομηνία εκδήλωσης`,
            `Heirloom: 90 ημέρες μετά την ημερομηνία εκδήλωσης`,
          ],
        },
        `Μετά τη λήξη της περιόδου διατήρησης, τα Δεδομένα Εκδήλωσης θα διαγραφούν οριστικά από τα συστήματά μας, περιλαμβανομένου του αποθηκευτικού χώρου υπολογιστικού νέφους (cloud). Η διαδικασία αυτή είναι μη αναστρέψιμη. Η Πλατφόρμα θα καταβάλει εύλογες προσπάθειες για την αποστολή υπενθυμίσεων μέσω email — περίπου επτά (7) ημέρες και είκοσι τέσσερις (24) ώρες πριν από την οριστική διαγραφή — στη διεύθυνση email που συνδέεται με τον λογαριασμό σας. Ωστόσο, η μη λήψη τέτοιων υπενθυμίσεων δεν παρατείνει την περίοδο διατήρησης ούτε γεννά υποχρέωση διατήρησης Δεδομένων Εκδήλωσης πέραν του καθορισμένου χρονικού πλαισίου.`,
        `Σας συνιστούμε ανεπιφύλακτα να προβείτε σε λήψη και να διατηρείτε αντίγραφα ασφαλείας του Περιεχομένου σας πριν από τη λήξη της περιόδου διατήρησης. Η Πλατφόρμα παρέχει σχετική λειτουργία λήψης για τον σκοπό αυτό.`,
        `Για περισσότερες πληροφορίες σχετικά με τον χειρισμό προσωπικών δεδομένων, ανατρέξτε στην Πολιτική Απορρήτου μας.`,
      ],
    },
    {
      heading: "16. Τροποποιήσεις των Όρων",
      content: [
        `Μπορούμε να ενημερώνουμε τους παρόντες Όρους κατά καιρούς. Σε περίπτωση ουσιωδών αλλαγών:`,
        {
          type: "list",
          items: [
            `Θα επικαιροποιηθεί η «Ημερομηνία ισχύος» στην αρχή των Όρων·`,
            `Θα ενημερωθούν οι εγγεγραμμένοι χρήστες μέσω email ή μέσω της Πλατφόρμας·`,
            `Θα δοθεί προθεσμία τουλάχιστον τριάντα (30) ημερών πριν τεθούν σε ισχύ οι αλλαγές.`,
          ],
        },
        `Η συνεχής χρήση της Πλατφόρμας μετά την ενεργοποίηση των ενημερωμένων Όρων συνιστά αποδοχή των αλλαγών. Εάν δεν συμφωνείτε, μπορείτε να τερματίσετε τον λογαριασμό σας.`,
      ],
    },
    {
      heading: "17. Μερική Ακυρότητα",
      content: [
        `Εάν οποιαδήποτε διάταξη των παρόντων Όρων κριθεί άκυρη, παράνομη ή ανίσχυρη, η εν λόγω διάταξη θα τροποποιείται στον ελάχιστο αναγκαίο βαθμό ή, εφόσον τούτο δεν είναι δυνατόν, θα διαγράφεται. Οι λοιπές διατάξεις θα παραμένουν σε πλήρη ισχύ και εφαρμογή.`,
      ],
    },
    {
      heading: "18. Εφαρμοστέο Δίκαιο και Δικαιοδοσία",
      content: [
        `Οι παρόντες Όροι διέπονται και ερμηνεύονται σύμφωνα με το δίκαιο της Ελληνικής Δημοκρατίας, αποκλειομένων των κανόνων σύγκρουσης δικαίων.`,
        `Οποιεσδήποτε διαφορές που προκύπτουν από ή σχετίζονται με τους παρόντες Όρους θα υπάγονται στην αποκλειστική δικαιοδοσία των δικαστηρίων Αθηνών, Ελλάδα.`,
        `Τίποτα στους παρόντες Όρους δεν θίγει τα δικαιώματά σας ως καταναλωτή βάσει της υποχρεωτικής νομοθεσίας προστασίας καταναλωτών της ΕΕ ή του κράτους μέλους κατοικίας σας. Όπου η εν λόγω νομοθεσία παρέχει υψηλότερο επίπεδο προστασίας, αυτές οι διατάξεις υπερισχύουν.`,
      ],
    },
    {
      heading: "19. Περιεχόμενο Τρίτων και Αναφορές",
      content: [
        `Μέρος του οπτικού υλικού που χρησιμοποιείται στην Πλατφόρμα προέρχεται από το Unsplash και χρησιμοποιείται βάσει της Άδειας Unsplash (https://unsplash.com/license), η οποία επιτρέπει χρήση για εμπορικούς και μη εμπορικούς σκοπούς χωρίς υποχρέωση αναφοράς. Αναγνωρίζουμε τους φωτογράφους των οποίων το έργο εμφανίζεται στην Πλατφόρμα:`,
        {
          type: "list",
          items: [
            `Φωτογραφίες από τον Jeremy Bishop στο Unsplash (https://unsplash.com/@jeremybishop)`,
          ],
        },
        `Άλλα στοιχεία, βιβλιοθήκες και υπηρεσίες τρίτων που χρησιμοποιούνται από την Πλατφόρμα παραμένουν ιδιοκτησία των αντίστοιχων κατόχων τους και χρησιμοποιούνται σύμφωνα με τις ισχύουσες άδειες χρήσης τους.`,
      ],
    },
    {
      heading: "20. Επικοινωνία",
      content: [
        `Εάν έχετε ερωτήσεις σχετικά με αυτούς τους Όρους, επικοινωνήστε μαζί μας:`,
        {
          type: "list",
          items: [
            `Email: privacy@agapae.gr`,
            `Εταιρεία: EnQube ΙΚΕ`,
            `Έδρα: Πάτρα, Ελλάδα`,
          ],
        },
      ],
    },
  ],
};

export default termsGR;
